import { render, staticRenderFns } from "./EmailAlertSKUItem.vue?vue&type=template&id=2de6bfd7&scoped=true&"
import script from "./EmailAlertSKUItem.vue?vue&type=script&lang=js&"
export * from "./EmailAlertSKUItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2de6bfd7",
  null
  
)

export default component.exports